import React from 'react'
import palette from '../../../../theme/palette'
import checkIcon from '../../../../images/icons/check_icon.svg'

export const SelectableCard = props => {
    return <div onClick={() => props.onChange && props.onChange(!props.selected)} style={{ position: 'relative', width: '230px', alignItems: 'cente', textAlign: 'center', cursor: props.onChange != null ? 'pointer' : 'default', display: 'flex', flexDirection: 'column', backgroundColor: 'white', border: `1px solid ${props.selected ? palette.primary.main : 'lightgrey'}`, boxShadow: '0px 0px 2px lightgrey', padding: '10px', fontSize: '14px', gap: '5px', borderRadius: '5px', color: 'grey' }}>
        <img src={checkIcon} style={{ position: 'absolute', top: '-12px', right: '-12px', opacity: props.selected ? 1 : 0 }}></img>
        <img src={props.icon} style={{ height: '40px' }}></img>
        <h2>{props.label}</h2>
        <span>{props.description}</span>
    </div>
}